import React from 'react';
import Link from 'gatsby-link';
import styles from "../css/contact.css";

const Contact = () => (
    <div id="contact-page">
        <section className="pageHeader" id="contact-header">
            <div className="container py-5">
                <h1>Contact</h1>
            </div>
        </section>
        <section className="container small-container text-center">
            <div className="row">
                <div className="col-12 col-sm-8 offset-sm-2">
                    <p>
                        If you have a query or would like further information on any of our services.
                        Please email us at <span className="text-orange">hello@kentweb.co.uk</span> or reach our via <a href="https://twitter.com/KentWebApps">Twitter</a>.


                        <a href="https://twitter.com/KentWebApps?ref_src=twsrc%5Etfw" className="twitter-follow-button" data-show-count="false">Follow &#64;KentWebApps</a>
                        <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8" />
                    </p>
                </div>

                <div className="col-12 text-center text-orange email-address">
                    Hello@KentWeb.co.uk
                </div>
            </div>
        </section>
    </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js